<template>
  <div class="centerTop flex-col-sb">

    <ul class="data-list flex-row-sb">
      <li class="data-item  flex-col-c-c">
        <span class="span-1">{{ title_text['clinic_count_val'].toLocaleString() }}</span>
        <span class="span-2">合作诊所</span>
      </li>
            <li class="data-item flex-col-c-c">
              <span class="span-1">{{ title_text['select_online_val'].toLocaleString() }}</span>
              <span class="span-2">云诊所</span>
            </li>
      <li class="data-item  flex-col-c-c">
        <span class="span-1">
          <CountTo :startVal="parseInt(cfl_old)" :endVal="parseInt(cfl_new)"
                   :duration='changeFast'></CountTo>
        </span>
        <span class="span-2">实时处方数</span>
      </li>
      <li class="data-item  flex-col-c-c">
        <span class="span-1">
            <CountTo :startVal="parseFloat(fees_old)" :endVal="parseFloat(fees_new)"
                    :duration='changeFast'></CountTo>
          </span>
          <span class="span-2">实时收入(元)</span>
        </li>
        <li class="data-item  flex-col-c-c">
        <span class="span-1">
            <CountTo :startVal="parseFloat(0)" :endVal="parseFloat(ssxl)"
                    :duration='changeFast'></CountTo>
          </span>
          <span class="span-2">实时销量(贴)</span>
        </li>
    </ul>
  </div>
</template>

<script>
import CountTo from 'vue-count-to';


export default {
  name: "centerTop",
  components: {
    CountTo,
  },
  mounted() {
    this.cal_suffix()
  },
  methods: {
    cal_suffix() {
      if (parseFloat(this.fees_old) != parseFloat(this.fees_new)) {
        this.div_flag = "1"
      } else {
        this.div_flag = ""
      }
    }
  },
  data() {
    return {
      changeFast: 1500,
      changeSlow: 1500,
      div_flag: ''
    };
  },
  props: {
    title_text: {
      default: null
    }, cfl_old: {
      default: 0
    }, cfl_new: {
      default: 0
    }, fees_old: {
      default: 0
    }, fees_new: {
      default: 0
    }, ssxl: {
      default: 0
    },
  },
  created() {

  },
  destroyed() {

  }
}
</script>
<style lang='scss' scoped>
@keyframes fade {
  from {
    opacity: 1.0
  }
  50% {
    opacity: 0.0
  }
  to {
    opacity: 1.0
  }
}


.centerTop {
  height: 150px;
  width: 100%;
  //border: 1px solid red;



  .data-list {
    margin-top: 30px;

    //.popc {
    //  position: fixed;
    //  top: 0;
    //  left: 0;
    //  right: 0;
    //  bottom: 0;
    //  z-index: 1999;
    //  background: rgba(0, 0, 0, 0.3);
    //  animation: fade 1000ms 3;
    //}

    .data-item {
      width: 18%;
      height: 75px;
      border: 1px solid rgba(96, 252, 178, 0.4);
      background: url("../assets/large/border.png") rgba(96, 252, 178, 0.05);
      background-size: 100% 100%;

      .span-1 {
        font-size: 22px;
        color: #F5E447;
      }

      .span-2 {
        font-size: 14px;
        color: #FFFFFF;
        opacity: .7;
      }
    }


  }


}
</style>
